import { render } from "./HistoryList.vue?vue&type=template&id=47ddbe71&scoped=true&ts=true"
import script from "./HistoryList.vue?vue&type=script&lang=ts"
export * from "./HistoryList.vue?vue&type=script&lang=ts"

import "./HistoryList.vue?vue&type=style&index=0&id=47ddbe71&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ddbe71"]])

export default __exports__